import type { ReactNode } from 'react'

const SkeletonItem = (): ReactNode => (
  <div className="animate-pulse rounded-md bg-skeleton-primary px-5 py-2.5 text-transparent lg:min-w-[140px]">
    .
  </div>
)

const TemplatesCategorySkeleton = (): ReactNode => (
  <div className="row-start-2 flex flex-col gap-3 lg:w-fit">
    <SkeletonItem />
    <div className="hidden flex-col gap-3 lg:flex lg:w-fit">
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
    </div>
  </div>
)

export default TemplatesCategorySkeleton
